import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { getCalendarDashBoard } from "../../helpers/api/api";

export const GET_CALENDAR_DASHBOARD = "GET_CALENDAR_DASHBOARD";

export const callGetCalendarDashboard = (inputs) => {
  const meta = {
    endpoint: (params) => getCalendarDashBoard(params),
    inputs,
    action: GET_CALENDAR_DASHBOARD,
    messages: {
      id: "calendarDashBoard",
      failure: "Could not get calendar dashboard data.",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  result: [],
};

const messages = {
  loadFailed: "Could not load Classroom.",
};

const saveCalendarDashboard = (state, action) => {
  return R.assoc("result", action.result, state);
};

export default reducer(
  initialState,
  GET_CALENDAR_DASHBOARD,
  saveCalendarDashboard,
  messages.loadFailed
);
